import { LANGUAGE } from '@/store/types';

export default {
  computed: {
    lang() {
      return this.$store.getters[LANGUAGE];
    },
    localeBackIcon() {
      return this.lang === 'fa' ? 'el-icon-arrow-right' : 'el-icon-arrow-left';
    },
    normalizedLang() {
      // for now server doesn't handle chinese language
      // so we use english strings for chinese
      if (this.lang === 'ch') return 'en';
      else return this.lang;
    },
  },
};
